//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SidebarBet from './SidebarBet.vue';

export default {
  name: 'WheelSidebarBets',
  components: {
    SidebarBet
  },
  props: {
    // 替代 Angular inject(WheelState) 中的 game 状态对象
    game: {
      type: Object,
      default: null
    },
    // 替代 Angular inject(WheelState) 中的 userBets 列表
    bets: {
      type: Array,
      default: () => []
    },
    // 是否启用吸顶/粘性下注项
    isStickyBet: {
      type: Boolean,
      default: true
    }
  }
};
